export default "__VITE_ASSET__DLLgM8ki__"